<template>
  <div class="v-company-info">
    <div class="left">
      <img src="../../assets/images/about/p2.png"/>
    </div>
    <div class="right">
      <h2>{{$t('AboutText.p2_title')}}</h2>
      <h5>{{$t('AboutText.p2_subtitle')}}</h5>
      <p>{{$t('AboutText.p2_content')}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "p2-company-info"
  }
</script>

<style scoped lang="scss">
  .en .v-company-info {
    .right {
      h2 {
        margin-top: 0;
      }
    }
  }

  .v-company-info {
    background: url('../../assets/images/home/p3-4-bg.png') right top no-repeat;
    background-size: auto 100%;
    display: flex;
    padding: 8vw 18vw 6vw 12vw;
    text-align: left;

    .left {
      flex-shrink: 0;

      img {
        width: 28vw;
        height: 28vw;
      }
    }

    .right {
      padding: 0 0 0 3.7vw;

      h2 {
        font-size: 3.13vw;
        font-weight: bold;
        margin-bottom: 3vw;
      }

      h5 {
        font-size: 1.25vw;
        font-weight: bold;
        margin-bottom: 1vw;
      }

      p {
        font-size: 1.25vw;
        line-height: 2.66vw;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/about/p2-company-info.vue